import React from "react";
import SectionHeader from "./SectionHeader";
import FadeIn from "./FadeIn";

export default function Experience() {
  const experiences = [
    {
      company: "Palfinger Maribor",
      position: "Intern",
      period: "April 2026 — June 2026",
      details: "Developed an internal web application (Palfinger Maps) using React, PHP, and MariaDB — a searchable directory of buildings, offices, devices, and personnel across the company's facilities.",
    },
  ];

  return (
    <section id="experience" className="w-full py-28 md:py-36 px-6 md:px-12 bg-Base border-t hairline selection:bg-Sapphire selection:text-Base">
      <div className="max-w-4xl w-full mx-auto">
        <SectionHeader number="03" label="Work" title="Experience" />

        <FadeIn>
        <div>
          {experiences.map((exp, index) => (
            <div
              key={index}
              className="grid md:grid-cols-[12rem_1fr] gap-2 md:gap-8 border-t hairline py-8"
            >
              <span className="label-caps pt-1.5">{exp.period}</span>

              <div>
                <h3 className="font-display font-medium text-Text text-2xl mb-1">
                  {exp.company}
                </h3>
                <h4 className="font-mono text-sm text-Sapphire mb-4">
                  {exp.position}
                </h4>
                <p className="text-Subtext0 font-sans text-base max-w-xl leading-relaxed">
                  {exp.details}
                </p>
              </div>
            </div>
          ))}
        </div>
        </FadeIn>
      </div>
    </section>
  );
}
